import SupplierSelector from "@/components/supplier/SupplierSelector";
import { useModalBehavior } from "@/hooks/behaviors";
import { SupplierPageVo } from "@/types/apis";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

type Props = {
  onSelect?: (rows?: SupplierPageVo[]) => void;
};

export const SearchSupplier = ({ onSelect }: Props) => {
  const { t } = useTranslation("inquiryManagement");
  const { open, openModal, closeModal } = useModalBehavior();

  const handleOk = (rows?: SupplierPageVo[]) => {
    closeModal();
    if (rows && rows.length > 0) {
      onSelect?.(rows);
    }
  };

  return (
    <>
      <Button
        style={{
          marginLeft: 10,
          marginBottom: 10,
        }}
        type="primary"
        onClick={() => openModal()}
      >
        {t("从供应商库选择")}
      </Button>

      <SupplierSelector
        selectionMode="multiple"
        open={open}
        onOk={handleOk}
        onClose={closeModal}
      />
    </>
  );
};
